module.exports = __webpack_public_path__ + "img/brand5.019bb934.png";